const certificateData = [
	{
		anchorProperties: {
			href: 'https://privacy.truste.com/privacy-seal/validation?rid=07326333-3522-463d-81bf-f00fd7171fff',
			target: '_blank',
			rel: 'nofollow,noopener',
			metric: { link: 'ftr_trust' },
		},
		imageProperties: {
			src: 'https://privacy-policy.truste.com/privacy-seal/seal?rid=07326333-3522-463d-81bf-f00fd7171fff',
			alt: 'TRUSTe',
			title: 'TRUSTe Privacy Certification',
			height: '37',
			width: '116',
			loading: 'lazy',
		},
	},
	{
		anchorProperties: {
			metric: { link: 'ftr_tag' },
		},
		imageProperties: {
			src: 'https://img.webmd.com/dtmcms/live/webmd/consumer_assets/site_images/layout/shared/tag-registered.png?resize=*:60px',
			alt: 'TAG Registered Seal',
			title: 'TAG Registered Seal',
			height: '54',
			width: '55',
			loading: 'lazy',
		},
	},
	{
		anchorProperties: {
			style: { cursor: 'pointer' },
			metric: { link: 'ftr_adchoices' },
			onclick: 'TRUSTeWidget.Tab.link()',
		},
		imageProperties: {
			src: 'https://img.webmd.com/dtmcms/live/webmd/consumer_assets/site_images/oncology/1/footer-images/ad-choice.png',

			// src: "https://choices.trustarc.com/get?name=admarker2.png",
			alt: 'Adchoices',
			title: 'Adchoices',
			height: '21',
			width: '74',
			loading: 'lazy',
		},
	},
];

export default certificateData;
